import React from 'react';
import PropTypes from 'prop-types';
import './NoResult.less';
import noResultImage from '../../assets/images/required/no-result.png';

const NoResult = (props) => (
  <div className="no-result-text-wrap">
    <div className="no-result-img-wrap">
      <img src={noResultImage} alt="результатов не найдено" />
    </div>
    <p className="no-result-text">По вашему запросу ничего не найдено</p>
  </div>
);

NoResult.propTypes = {};

export default NoResult;
